import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { E_SIGN_MSG_PATH, SPECIAL_CONDITIONS_PATH } from '../constants/route.constants';

@Injectable({
  providedIn: 'root',
})
export class StartGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const status = route.paramMap.get('status');

    if (status === '1') {
      this.router.navigate([SPECIAL_CONDITIONS_PATH]);
    } else {
      this.router.navigate([E_SIGN_MSG_PATH, status]);
    }
    return true;
  }
}
